import { render, staticRenderFns } from "./groupClassify.vue?vue&type=template&id=011de01b&scoped=true&"
import script from "./groupClassify.vue?vue&type=script&lang=js&"
export * from "./groupClassify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011de01b",
  null
  
)

export default component.exports